export interface QuoteRequest {
  tenderReference: string,
  quoteReference: string,
  version: number,
  status: QuoteStatus,
  token: string,
  supplier: Supplier,
  creationDate: string,
  expirationDate: string,
  acceptedCurrencies: string[],
  contactPerson: Contact,
  requirements?: Requirements,
  instructions?: string,
  shipments: Shipment[],
  amount?: number,
  currency?: string,
}

export interface Supplier {
  id: string,
  name: string,
  address: string,
  email: string,
}

export interface Contact {
  name: string,
  email: string
}

export interface Requirements {
  truck?: VehicleRequirements,
  trailer?: VehicleRequirements,
  temperature?: TemperatureRequirements
}

export interface VehicleRequirements {
  details: string
}

export interface TemperatureRequirements {
  mode?: string
  minimum?: number
  maximum?: number
}

export interface Shipment {
  pickup: Stop,
  delivery: Stop,
  cargoItems: Cargo[],
}

export interface Stop {
  address: Address
  windowStartDate: string,
  windowEndDate: string,
}

export interface Address {
  countryCode: string,
  city: string,
  postalCode: string
}

export interface Cargo {
  numberOfPackages: number,
  packageType: PackageType,
  grossWeight: number,
  volume: number,
  length?: number,
  width?: number,
  height?: number,
  stackable?: boolean,
  loadingMeters?: number,
  description: string,
  dangerousGoods: DangerousGoods[]
}

export interface DangerousGoods {
  unCode?: string,
  limitedQuantity?: boolean,
  exceptedQuantity?: boolean,
  name?: string,
  classification?: string,
  packingGroup?: string,
  notOtherwiseSpecified?: boolean,
  tunnelCode?: string
  weight?: number,
  netExplosiveMass?: number,
  volume?: number,
  highConsequence?: boolean,
  environmentalHazard?: boolean,
  technicalName?: string,
  englishTechnicalName?: string,
  adrExemptions?: string,
  adrPackage?: ADRPackageData,
}

export interface ADRPackageData {
  number?: string,
  type?: string,
}

export enum PackageType {
  PALLET = 'PALLET',
  BOX = 'BOX',
  EURO_PALLET_EXCHANGEABLE = 'EURO PALLET EXCHANGEABLE',
}

export enum QuoteStatus {
  OPEN = 'OPEN',
  SUBMITTED = 'SUBMITTED',
  REJECTED = 'REJECTED',
  CLOSED = 'CLOSED',
}

export interface QuoteAnswerFormValues {
  quoteAmount: number,
  currency: string,
  carrierQuoteReference: string, // the one user provides
  quoteExpirationDate: string,
  quoteExpirationTime: string,
  quoteExpirationTimezone: string,
  comments: string,
  carrierContact: string,
  carrierContactEmail: string,
  days: string,
}

export interface AbstractQuoteAnswer {
  quoteReference: string
  version: number
  creationDate?: string
  comments?: string | null
  offerReference?: string | null
  contact?: QuoteAnswerContact | null
  status: QuoteStatus
  editable?: boolean
}

export interface QuoteOffer extends AbstractQuoteAnswer {
  status: QuoteStatus
  expirationDate?: string
  expirationDateTimezone?: string
  amount: string
  currency: string
  transitDuration: string
}

export interface QuoteRejection extends AbstractQuoteAnswer {
  status: QuoteStatus
}

export type QuoteAnswer = QuoteOffer | QuoteRejection

export interface QuoteAnswerContact {
  name: string,
  email: string,
}

